var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaAreaApertaFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.88 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.83,7.46a6.07044,6.07044,0,0,0,.03-.61A6.862,6.862,0,0,0,3.23,5.73,5.27874,5.27874,0,0,0,0,10.58a5.22324,5.22324,0,0,0,4.71,5.2,4.27823,4.27823,0,0,0,.52.03H7.85v3.14H4.71a.525.525,0,1,0,0,1.05H15.17a.525.525,0,1,0,0-1.05H12.03V15.81h3.7a4.264,4.264,0,0,0,1.1-8.35ZM10.99,18.95H8.89V15.81h2.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaAreaApertaFill);
export default __webpack_public_path__ + "static/media/iconaAreaApertaFill.4872d4b56f5803cedd1383a39aa30ea6.svg";
export { ForwardRef as ReactComponent };